module.exports = __webpack_public_path__ + "static/media/Banner-spa-1.13153c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/best-deals/Banner-spa-1.png
// module id = 1950
// module chunks = 0